<div id="app-menu-group" trapFocus (keyup.escape)="close()">
    <div id="app-menu-group-header" autofocus tabindex="0">
        <button
            *ngIf="displayBackButton"
            id="app-menu-group-back-btn"
            (click)="close()"
            pButton
            class="p-button-rounded p-button-text p-button-secondary"
            aria-label="Close switch group">
            <i class="fa-thin fa-angle-left"></i>
        </button>
        <div>
            <i class="fa-light fa-arrow-right-arrow-left" id="switch-group-icon"></i>
            <label for="switch-group-icon" id="switch-group-label">{{ 'switchGroup' | translate }}</label>
        </div>
    </div>

    <div id="app-menu-group-body">
        <nav id="user-group-list">
            <button
                [id]="'user-group-btn-' + group.id"
                (click)="selectGroup(group)"
                *ngFor="let group of userGroups"
                [class.selected]="group.id === selectedGroupId"
                class="user-group-item">
                <i class="fa-light fa-circle-check selected-icon" [id]="'user-group-icon-' + group.id"></i>
                <label [for]="'user-group-icon-' + group.id" [id]="'user-group-label-' + group.id">
                    <span class="group-label">{{ 'group' | translate }}:</span>
                    {{ group.name }}
                </label>
            </button>
        </nav>
    </div>
</div>
